import React from "react"
import { func, node, string } from "prop-types"
import { useNavigate } from "@tanstack/react-router"

class Boundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidUpdate(prevProps) {
    // Reset on navigation so the next route can render after a previous crash.
    if (this.state.hasError && prevProps.locationKey !== this.props.locationKey) {
      this.setState({ hasError: false })
    }
  }

  componentDidCatch(error, info) {
    if (import.meta.env.DEV) {
      console.error("RouteErrorBoundary caught:", error, info)
    }
    this.props.onError()
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}

Boundary.propTypes = {
  onError: func.isRequired,
  locationKey: string,
  children: node.isRequired
}

function RouteErrorBoundary({ children, locationKey }) {
  const navigate = useNavigate()
  return (
    <Boundary onError={() => navigate({ to: "/error", replace: true })} locationKey={locationKey}>
      {children}
    </Boundary>
  )
}

RouteErrorBoundary.propTypes = {
  children: node.isRequired,
  locationKey: string
}

export default RouteErrorBoundary
